export function isPackAvailableForMode(pack, mode) {
    const modes = pack.allowedConsultationModes ?? pack.allowedConsultations;
    if (!modes)
        return true;
    return modes.includes(mode);
}
export function isPackAllowedForPatient(pack, patientTab, selectedPatient, activeSessionPacks) {
    if (pack.allowFamilyBooking === true)
        return true;
    const owned = activeSessionPacks.find((entry) => entry.packageConfigId === pack.id);
    if (!owned)
        return true;
    if (patientTab === "new")
        return false;
    if (!selectedPatient)
        return true;
    return selectedPatient.id === owned.purchasedBy;
}
export function isOwnedPackAllowedForPatient(pack, patientTab, selectedPatient) {
    if (pack.allowFamilyBooking === true)
        return true;
    if (patientTab === "new")
        return false;
    if (!selectedPatient)
        return true;
    return selectedPatient.id === pack.purchasedBy;
}
export function isOwnedPackAvailableForDuration(pack, selectedDuration) {
    if (pack.durationMins == null)
        return true;
    if (selectedDuration == null)
        return true;
    return pack.durationMins === selectedDuration;
}
